import { z } from 'zod';

export const temperatureSettingsSchema = z.object({
  setpoint_tolerance: z.number().min(0).max(5).default(0.5),
  return_temp_tolerance: z.number().min(0).max(10).default(2.5),
  activity_feed_threshold: z.number().min(0).max(20).default(5.0),
  questioning_trigger: z.number().min(0).max(20).default(10.0),
  yard_check_tolerance: z.number().min(0).max(5).default(2.5)
});

export const automationSettingsSchema = z.object({
  unit_questioning_enabled: z.boolean().default(false),
  unit_questioning_skippable: z.boolean().default(true),
  // Unit check enforcement - warns users when completing trains with unchecked units
  unit_check_enforcement_enabled: z.boolean().default(true)
});

export const fuelSettingsSchema = z.object({
  default_fuel_type: z.string().default('diesel'),
  auto_calculate_consumption: z.boolean().default(true),
  consumption_rate_threshold: z.number().min(0).max(100).default(15.0)
});

export const appSettingsSchema = z.object({
  app_name: z.string().default('RMS'),
  maintenance_mode: z.boolean().default(false),
  debug_mode: z.boolean().default(false),
  max_upload_size: z.number().min(1).max(100).default(10)
});

// Utilization color threshold settings schema
// These thresholds determine the color coding for shift utilization percentages
// Colors: >= high_threshold (green), >= good_threshold (yellow), >= moderate_threshold (orange), < moderate_threshold (red)
export const utilizationSettingsSchema = z.object({
  // Threshold for high utilization (green) - percentage
  high_threshold: z.number()
    .min(0, 'High threshold must be between 0 and 100')
    .max(100, 'High threshold must be between 0 and 100')
    .default(80),

  // Threshold for good utilization (yellow) - percentage
  good_threshold: z.number()
    .min(0, 'Good threshold must be between 0 and 100')
    .max(100, 'Good threshold must be between 0 and 100')
    .default(60),

  // Threshold for moderate utilization (orange) - percentage
  moderate_threshold: z.number()
    .min(0, 'Moderate threshold must be between 0 and 100')
    .max(100, 'Moderate threshold must be between 0 and 100')
    .default(40)
});

export type TemperatureSettings = z.infer<typeof temperatureSettingsSchema>;
export type AutomationSettings = z.infer<typeof automationSettingsSchema>;
export type FuelSettings = z.infer<typeof fuelSettingsSchema>;
export type AppSettings = z.infer<typeof appSettingsSchema>;
export type UtilizationSettings = z.infer<typeof utilizationSettingsSchema>;